module.exports = __webpack_public_path__ + "img/partner5.55ceb5a3.png";